import type { ReactNode } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EditorPage from './pages/EditorPage';
import AuditPage from './pages/AuditPage';
import ApprovalsPage from './pages/ApprovalsPage';
import LoginPage from './pages/LoginPage';
import { TopBar } from './components/TopBar';
import { StatusBar } from './components/StatusBar';
import { useAuthStore } from './store/authStore';

function Protected({ children }: { children: ReactNode }) {
  const token = useAuthStore((s) => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return (
    <div className="app-shell">
      <TopBar />
      {children}
      <StatusBar />
    </div>
  );
}

export default function App() {
  const token = useAuthStore((s) => s.token);

  return (
    <Routes>
      <Route path="/login" element={token ? <Navigate to="/editor" replace /> : <LoginPage />} />
      <Route path="/" element={<Navigate to="/editor" replace />} />
      <Route path="/editor" element={<Protected><EditorPage /></Protected>} />
      <Route path="/audit" element={<Protected><AuditPage /></Protected>} />
      <Route path="/approvals" element={<Protected><ApprovalsPage /></Protected>} />
    </Routes>
  );
}
